<nav id="navbar" class="navbar navbar-expand-lg navbar-light">
  <div class="container-fluid">
    <a *ngIf="this.showToUser" class="navbar-brand" routerLink="/">
      <img src="assets/imgs/Bhavani_Negro.png" width="140" height="19" alt="Logo" />
    </a>
    <img class="m-auto" *ngIf="!this.showToUser" src="assets/imgs/Bhavani_Negro.png" width="140" height="19"
      alt="Logo" />
    <button *ngIf="this.showToUser" class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse"
      data-bs-target="#navbarScroll" aria-controls="navbarScroll" aria-expanded="false" aria-label="Toggle navigation">
      <span class="toggler-icon top-bar"></span>
      <span class="toggler-icon middle-bar"></span>
      <span class="toggler-icon bottom-bar"></span>
    </button>
    <div *ngIf="this.showToUser" class="collapse navbar-collapse" id="navbarScroll">
      <ul class="navbar-nav ms-auto my-2 my-lg-0 navbar-nav-scroll">
        <li *ngFor="let element of navigation_links" class="nav-item ps-3 ps-lg-0">
          <a *ngIf="!element.external" class="nav-link" aria-current="page" [routerLink]="element.path"
            routerLinkActive="active">{{ element.name }}</a>
          <a *ngIf="element.external" class="nav-link" aria-current="page" [href]="element.path">{{ element.name }}</a>
        </li>
      </ul>
    </div>
  </div>
</nav>